<template>
  <v-container class="ma-auto px-4">
    <v-col v-if="bonusDetail.length > 0" cols="12" lg="6" class="pt-0 mx-auto">
      <v-row>
        <v-col cols="12" class="px-0 pt-0">
          <v-card elevation="0" rounded="lg">
            <v-card-text class="py-2 px-0">
              <!-- ========== ========== CountItem ========== ========== -->
              <div class="d-flex align-center">
                <v-btn
                  v-if="showBonusDetailCountItemNextBack"
                  icon
                  small
                  @click="handleBackBonus"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="d-flex" style="width: 100%">
                  <div
                    v-for="(item, index) in bonusDetailCountItem"
                    :key="index"
                    class="d-flex"
                    :style="{
                      flex:
                        index + 1 < bonusDetailCountItem.length ||
                        bonusDetailCountItem.length == 1
                          ? '1'
                          : '0.5',
                    }"
                  >
                    <div class="container-box-bonus">
                      <div class="text-center">
                        <div style="font-weight: 700">
                          {{ item.calculation_type == "multiply" ? "x" : "+"
                          }}{{ item.point | commaPoint }}
                        </div>
                      </div>
                      <div
                        class="box-bonus d-flex justify-center align-center"
                        :style="{
                          'background-color': item.success
                            ? '#8BC34A'
                            : '#E0E0E0',
                        }"
                      >
                        <v-icon color="#ffffff">{{
                          item.success ? "mdi-check" : "mdi-gift-outline"
                        }}</v-icon>
                      </div>
                      <div class="text-center">
                        <div class="text-inside">
                          {{
                            $t("collectedItemCount", { count: item.item_count })
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="index + 1 < bonusDetailCountItem.length"
                      class="line-bonus"
                      :style="{
                        'background-color': bonusDetailCountItem[index + 1]
                          .success
                          ? '#8BC34A'
                          : '#E0E0E0',
                      }"
                    ></div>
                  </div>
                </div>
                <v-btn
                  v-if="showBonusDetailCountItemNextBack"
                  icon
                  small
                  @click="handleNextBonus"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </div>
              <!-- ========== ========== SpecificItem ========== ========== -->
              <div
                v-if="bonusDetailSpecificItem.length > 0"
                class="mt-2 d-flex"
              >
                <v-chip
                  class="text-center mr-0 ml-auto"
                  :color="site.color"
                  small
                  outlined
                  @click="dialogBonusDetailSpecificItem = true"
                >
                  {{ $t("extraBonus") }}
                  <v-icon small> mdi-chevron-right </v-icon>
                </v-chip>

                <v-dialog
                  v-model="dialogBonusDetailSpecificItem"
                  max-width="400"
                >
                  <v-card>
                    <v-card-title class="text-h6">
                      {{ $t("extraBonus") }}
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        @click="dialogBonusDetailSpecificItem = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-container class="pt-0">
                      <v-row no-gutters class="px-3">
                        <v-col
                          cols="12"
                          v-for="(item, index) in bonusDetailSpecificItem"
                          :key="index"
                        >
                          <v-row no-gutters>
                            <v-col
                              cols="12"
                              class="text-start pa-0 d-flex justify-space-between align-center"
                            >
                              <div class="d-flex align-center py-2">
                                <p class="ma-0" style="font-size: 16px">
                                  {{ $t("collected") }}
                                </p>
                                <v-img
                                  class="ml-2 rounded"
                                  contain
                                  :aspect-ratio="1"
                                  width="60px"
                                  :lazy-src="require('@/assets/images/image.png')"
                                  :src="item.image_url"
                                />
                              </div>

                              <v-chip
                                class="ma-2 text-center white--text"
                                style="font-size: 20px; font-weight: 600"
                                :color="item.success ? '#8BC34A' : '#E0E0E0'"
                              >
                                {{
                                  item.calculation_type == "multiply"
                                    ? "x"
                                    : "+"
                                }}{{ item.point | commaPoint }}
                              </v-chip>
                            </v-col>
                          </v-row>
                          <v-divider
                            v-if="index + 1 < bonusDetailSpecificItem.length"
                          ></v-divider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <!-- ========== ========== Data ========== ========== -->
    <v-col cols="12" lg="6" class="mx-auto pa-0" justify="center">
      <QuestTrackingDataItemNormal
        v-if="questTrackingDisplayType == 'normal'"
        :questTrackingData="questTrackingData"
        :conditionSpecial="conditionSpecial"
        @onOpenDialog="openDialog"
      />

      <QuestTrackingDataItemRoute
        v-if="questTrackingDisplayType == 'route'"
        :questTrackingData="questTrackingData"
        :conditionSpecial="conditionSpecial"
        @onOpenDialog="openDialog"
      />
    </v-col>

    <!-- dialog detail activity -->
    <DialogItemQuestTracking
      :item="selectItem"
      :keyComponent="keyComponent"
      :dialogItemQuestTracking="dialogItemQuestTracking"
      :site="site"
      @close="dialogItemQuestTracking = false"
    />
  </v-container>
</template>

<script>
import DialogItemQuestTracking from "@/components/activity/dialogItemQuestTracking.vue";
import { mapState } from "vuex";
import QuestTrackingDataItemNormal from "../../../../components/activity/quest-tracking-data-item-normal.vue";
import QuestTrackingDataItemRoute from "../../../../components/activity/quest-tracking-data-item-route.vue";

export default {
  name: "QuestTrackingData",
  props: {
    questTrackingData: {
      type: Array,
      required: true,
    },
    conditionSpecial: {
      type: Object,
    },
  },
  components: {
    DialogItemQuestTracking,
    QuestTrackingDataItemNormal,
    QuestTrackingDataItemRoute,
  },
  data() {
    return {
      selectItem: null,
      keyComponent: 0,
      dialogItemQuestTracking: false,
      questTrackingDisplayType: "normal",

      bonusDetail: [],
      bonusDetailCountItemDefault: [],
      pageDetailCountItem: 0,
      sizeBonusDetailCountItem: {
        xs: 3,
        not_xs: 4,
      },

      bonusDetailSpecificItem: [],
      dialogBonusDetailSpecificItem: false,
    };
  },

  mounted() {
    let _bonusDetailDefault = [];
    if (this.conditionSpecial != null) {
      if (Array.isArray(this.conditionSpecial.bonus_detail)) {
        const bonus_detail = [...this.conditionSpecial.bonus_detail];
        _bonusDetailDefault = [...bonus_detail];
      }
      if (this.conditionSpecial.is_use_completion_sequence) {
        this.questTrackingDisplayType = "route";
      }
    }

    // ========== ========== ========== ==========
    const _questTrackingData = [...this.questTrackingData];
    const countIsCompleted = _questTrackingData.filter(
      (x) => x.is_completed
    ).length;
    _bonusDetailDefault = _bonusDetailDefault.map((x) => {
      if (x.bonus_type == "specific_item") {
        const model = _questTrackingData.find((q) =>
          q.code.includes(`-${x.item_code}`)
        );
        if (model) {
          x.image_url = model.image_url;
          x.success = model.is_completed;
        }
      }
      return x;
    });
    this.bonusDetail = [..._bonusDetailDefault];
    // ========== ========== ========== ==========
    this.bonusDetailCountItemDefault = _bonusDetailDefault.filter(
      (x) => x.bonus_type == "count_item"
    );
    this.bonusDetailCountItemDefault.sort(
      (a, b) => Number(a.item_count) - Number(b.item_count)
    );
    this.bonusDetailCountItemDefault = this.bonusDetailCountItemDefault.map(
      (x) => {
        x.success = false;
        if (countIsCompleted >= Number(x.item_count)) {
          x.success = true;
        }
        return x;
      }
    );
    // ========== ========== ========== ==========
    const breakpoint = this.$vuetify.breakpoint.name;
    const limit =
      breakpoint == "xs"
        ? this.sizeBonusDetailCountItem.xs
        : this.sizeBonusDetailCountItem.not_xs;
    const total = this.bonusDetailCountItemDefault.length;
    const total_success = this.bonusDetailCountItemDefault.filter(
      (x) => x.success
    ).length;
    const total_wait = total - total_success;
    const success_page_full = Math.floor(total_success / limit);
    const success_page_over = total_success % limit;
    if (success_page_over == 0 && total_wait > 0) {
      this.pageDetailCountItem = total <= limit ? 0 : success_page_full;
    } else {
      this.pageDetailCountItem = 0;
    }
    // ========== ========== ========== ==========
    this.bonusDetailSpecificItem = _bonusDetailDefault.filter(
      (x) => x.bonus_type == "specific_item"
    );
  },
  methods: {
    openDialog(item) {
      this.selectItem = item;
      this.selectItem.mode = item.mode;
      this.dialogItemQuestTracking = true;
      this.keyComponent = item.id;
    },

    handleNextBonus() {
      // ========== ========== ========== ==========
      const breakpoint = this.$vuetify.breakpoint.name;
      const limit =
        breakpoint == "xs"
          ? this.sizeBonusDetailCountItem.xs
          : this.sizeBonusDetailCountItem.not_xs;
      let start = this.pageDetailCountItem * limit;
      let end = start + limit;
      let list = this.bonusDetailCountItemDefault.slice(start, end);
      if (list.length < limit) {
        const diff = limit - list.length;
        start = start - diff;
        end = start + limit;
        list = this.bonusDetailCountItemDefault.slice(start, end);
      }
      // ========== ========== ========== ==========
      const count_limit = this.pageDetailCountItem * limit + list.length;
      if (count_limit > this.bonusDetailCountItemDefault.length) return;
      this.pageDetailCountItem++;
    },
    handleBackBonus() {
      if (this.pageDetailCountItem == 0) return;
      this.pageDetailCountItem--;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    bonusDetailCountItem() {
      // ========== ========== ========== ==========
      const breakpoint = this.$vuetify.breakpoint.name;
      const limit =
        breakpoint == "xs"
          ? this.sizeBonusDetailCountItem.xs
          : this.sizeBonusDetailCountItem.not_xs;
      let start = this.pageDetailCountItem * limit;
      let end = start + limit;
      let list = this.bonusDetailCountItemDefault.slice(start, end);
      if (list.length < limit) {
        const diff = limit - list.length;
        start = start - diff;
        end = start + limit;
        list = this.bonusDetailCountItemDefault.slice(start, end);
      }
      // ========== ========== ========== ==========
      if (this.bonusDetailCountItemDefault.length <= limit) {
        list = [...this.bonusDetailCountItemDefault];
      }
      return list;
    },
    showBonusDetailCountItemNextBack() {
      let check = false;
      const breakpoint = this.$vuetify.breakpoint.name;
      const limit =
        breakpoint == "xs"
          ? this.sizeBonusDetailCountItem.xs
          : this.sizeBonusDetailCountItem.not_xs;
      if (this.bonusDetailCountItemDefault.length > limit) {
        check = true;
      }
      return check;
    },
  },
  filters: {
    commaPoint(value) {
      const number = Number(value);
      if (number == 0) {
        return "0";
      } else if (!isNaN(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "";
    },
  },
  watch: {
    "$vuetify.breakpoint.name": {
      handler() {
        // ========== ========== ========== ==========
        const breakpoint = this.$vuetify.breakpoint.name;
        const limit =
          breakpoint == "xs"
            ? this.sizeBonusDetailCountItem.xs
            : this.sizeBonusDetailCountItem.not_xs;
        const total = this.bonusDetailCountItemDefault.length;
        const total_success = this.bonusDetailCountItemDefault.filter(
          (x) => x.success
        ).length;
        const total_wait = total - total_success;
        const success_page_full = Math.floor(total_success / limit);
        const success_page_over = total_success % limit;
        if (success_page_over == 0 && total_wait > 0) {
          this.pageDetailCountItem = total <= limit ? 0 : success_page_full;
        } else {
          this.pageDetailCountItem = 0;
        }
        // ========== ========== ========== ==========
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.line-bonus {
  flex-grow: 1;
  height: 8px;
  margin-top: 36px;
}
.container-box-bonus {
  flex: 1;
}
.box-bonus {
  height: 40px;
  border-radius: 12px;
  border: 4px solid #ffffff;
  box-sizing: border-box;
}
.text-inside {
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>